import { createContext, useContext, useState } from "react";

const StoreContext = createContext();

export function StoreProvider({ children }){
    const [store, setStore] = useState({});

    return(
        <StoreContext.Provider value={{store, setStore}} >
            {children}
        </StoreContext.Provider>
    );
}

export function useStore(){
    const context = useContext(StoreContext);
    if(!context) throw new Error(`StoreProvider 안에서 사용해야 합니다`);
    return context.store;
}

export function useSetStore(){
    const context = useContext(StoreContext);
    if(!context) throw new Error(`StoreProvider 안에서 사용해야 합니다`);
    return context.setStore;
}
